module.exports = __webpack_public_path__ + "static/media/legal-review-builder-help-2.a1be8e16.svg";